{
    "baseApiUri": "https://apis.theamidaarmy.com"
}